import Actions   from "../../model/constant/actions"

export const setTargetUser = (userId: number) => (dispatch, getState) => {
  dispatch({
    type   : Actions.SET_TARGET_USER,
    userId : userId
  })
}
